"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
const TextInputPropTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,
  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,
  /** What HTML input type the underlying input should be set to. */
  type: _propTypes.default.oneOf(['text', 'password', 'date', 'email', 'time', 'tel', 'search', 'number', 'hidden']),
  /** Text to display in the field before a user starts to type in the input. */
  placeholder: _propTypes.default.string,
  /** A custom aria-label to use for the input. */
  'aria-label': _propTypes.default.string,
  /** A custom label (typically a Label component) to display above the input. */
  label: _propTypes.default.element,
  /** A regular expression that the input value is checked against for validation. */
  pattern: _propTypes.default.string,
  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,
  /** Disallows user interaction. */
  disabled: _propTypes.default.bool,
  /** Whether to show a loading animation inside of the component. */
  loading: _propTypes.default.bool,
  /** Whether the field should be auto focused when mounted. */
  autoFocus: _propTypes.default.bool,
  /** Whether the field should be focused when the component receives new props. */
  focus: _propTypes.default.bool,
  /** A custom validation error (typically a FormElementError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element,
  /** The default value to display in the input when mounted. */
  defaultValue: _propTypes.default.string,
  /** A custom icon (typically an Icon component) to show in the input field. */
  icon: _propTypes.default.element,
  /** If an icon is provided, whether it should appear on the left or right side of the input field. */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  /** A custom help element to place below the input. */
  helpNode: _propTypes.default.node,
  /** Applies proper styling to display this field inline in a form. */
  inline: _propTypes.default.bool,
  /** Specifies that the input field is read-only. */
  readOnly: _propTypes.default.bool,
  /** Specifies the maximum number of characters allowed. */
  maxLength: _propTypes.default.number,
  /** Specifies the minimum value when type is `date` or `number`. */
  min: _propTypes.default.number,
  /** Specifies the maximum value when type is `date` or `number`. */
  max: _propTypes.default.number,
  /** A string to use as a mask. See <a href="https://github.com/sanniassin/react-input-mask#mask--string" target="_blank">react-input-mask</a>. */
  mask: _propTypes.default.string,
  /** Character to cover unfilled editable parts of mask. See <a href="https://github.com/sanniassin/react-input-mask#maskchar--string" target="_blank">react-input-mask</a>. */
  maskChar: _propTypes.default.string,
  /** Additional props to pass to the input element */
  additionalInputProps: _propTypes.default.object,
  /**
   * Function to execute when the input changes.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onChange: _propTypes.default.func,
  /**
   * Function to execute when the input is focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onFocus: _propTypes.default.func,
  /**
   * Function to execute when the input loses focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onBlur: _propTypes.default.func,
  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func
};
var _default = exports.default = TextInputPropTypes;